var _circle, _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPromotionStandart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 83,
    viewBox: "0 0 82 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 48.5,
    r: 48.5,
    fill: "url(#paint0_linear_725_9939)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25.5254,
    y: 25.5264,
    width: 45.9474,
    height: 45.9474,
    rx: 3.305,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_725_9939)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.2774 34.2697C64.3866 33.326 63.5926 32.5246 62.648 32.6248L43.4601 34.6618C42.2237 34.793 41.6882 36.2963 42.5633 37.1797L47.41 42.0724C47.9578 42.6254 47.9847 43.5079 47.4716 44.0932L31.675 62.1139C31.2128 62.6412 31.1844 63.4219 31.6052 63.9828C32.1056 64.6497 33.0589 64.7753 33.7128 64.2581L52.6738 49.2588C53.266 48.7903 54.1157 48.8417 54.6471 49.3781L59.533 54.3105C60.4081 55.1938 61.9163 54.6726 62.0593 53.4375L64.2774 34.2697Z",
    fill: "url(#paint1_linear_725_9939)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_725_9939",
    x1: 48.5,
    y1: 0,
    x2: 41.7787,
    y2: 168.517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3244E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B278F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_725_9939",
    x1: 64.4904,
    y1: 32.4294,
    x2: 4.73792,
    y2: 84.8848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3244E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B278F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_725_9939"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45.4175,
    height: 45.4175,
    fill: "white",
    transform: "translate(48.6016 17.3579) rotate(45.2707)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromotionStandart);
export default __webpack_public_path__ + "static/media/promotion-standart.d6d00c66e0473a74a124ce9fa391acd0.svg";
export { ForwardRef as ReactComponent };